// src/components/FilterDropdown.js
import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setFilterType, selectFilterType } from '../../rtk/slices/filterSlice/filterSlice';

const FilterDropdown = () => {
  const dispatch = useDispatch();
  const filterType = useSelector(selectFilterType);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const applyFilter = (filter) => {
    dispatch(setFilterType(filter));
    setDropdownOpen(false); // Close dropdown after selection
  };

  return (
    <Dropdown className='w-auto' isOpen={dropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle caret
       style={{
        backgroundColor: '#C09834',
        color: 'white',
        borderColor: '#C09834'
      }}
      >
        {filterType}
      </DropdownToggle>
      <DropdownMenu

        style={{
          backgroundColor: '#1f1f1f',
          color: 'white',
        }}>
        <DropdownItem onClick={() => applyFilter('All')}>All</DropdownItem>
        <DropdownItem onClick={() => applyFilter('Today')}>Today</DropdownItem>
        <DropdownItem onClick={() => applyFilter('Last week')}>Last week</DropdownItem>
        <DropdownItem onClick={() => applyFilter('Last month')}>Last month</DropdownItem>
        <DropdownItem onClick={() => applyFilter('Last 3 months')}>Last 3 months</DropdownItem>
        <DropdownItem onClick={() => applyFilter('Last 6 months')}>Last 6 months</DropdownItem>
        <DropdownItem onClick={() => applyFilter('Last year')}>Last year</DropdownItem>
        <DropdownItem onClick={() => applyFilter('Custom')}>Custom</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default FilterDropdown;
